import { editUserdata } from "./generalHelper";

/**
 * Monitors specific response headers and updates app state accordingly.
 * Should be called after each fetch/AJAX request.
 *
 * @param {Response} response - The fetch response object
 */
export function monitorResponseHeaders(response) {
  if (!response || typeof response.headers?.get !== "function") return;

  // Monitor headers
  const newAccessToken = response.headers.get("New-Access-Token");
  const newRefreshToken = response.headers.get("New-Refresh-Token");
  const newLangCode = response.headers.get("New-Lang-Code");
 

  if (newAccessToken) {
    editUserdata("is_authenticated", "true");
    localStorage.setItem("is_authenticated", "true");
  }

  if (newRefreshToken) {
    editUserdata("is_authenticated", "true");
  }

  if (newLangCode) {
    editUserdata("lang", newLangCode);
  }
}
